import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Row,
  Col,
} from 'reactstrap';
import { useIntl } from 'react-intl';

const ImporterModalConfirmation = ({
  importer,
  importData,
  resetImportState,
}) => {
  const intl = useIntl();

  return (
    <Row className="modal-import-confirmation">
      <Col className="center">
        <h4>{intl.formatMessage({
          defaultMessage: 'Your import from {name} has started',
        }, { name: importer.name })}
        </h4>
        <p>
          {intl.formatMessage({
            defaultMessage: `This may take a while depending on the total size of the files 
              selected.{br} You can close this window to continue working - we will notify
              you when the import is complete.`,
          }, { br: <br /> })}
        </p>
        <p>
          {importData.collection ? (
            <Button
              tag="a"
              href={`/collections/${importData.collection.uuid}`}
              target="_blank"
            >
              {intl.formatMessage({ defaultMessage: 'Browse the Collection' })}
            </Button>
          ) : (
            <Button
              tag="a"
              href="/files"
              target="_blank"
            >
              {intl.formatMessage({ defaultMessage: 'Visit your workspace' })}
            </Button>
          )}
          {' '}
          <Button
            onClick={resetImportState}
          >
            {intl.formatMessage({ defaultMessage: 'Start new import' })}
          </Button>
        </p>
      </Col>
    </Row>
  );
};

ImporterModalConfirmation.propTypes = {
  importer: PropTypes.object.isRequired,
  importData: PropTypes.object.isRequired,
  resetImportState: PropTypes.func.isRequired,
};

export default ImporterModalConfirmation;
